
import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Product } from 'src/app/models/product.model';
import { CrudService } from 'src/app/services/crud.service';
import CustomStore from 'devextreme/data/custom_store';
import { ProductGroup } from 'src/app/models/product-group.model';
import { Suppliers } from 'src/app/models/suppliers.model';
import { Warehouse } from 'src/app/models/warehouse.model';
import { DxDataGridComponent, DxPopupModule, DxDataGridModule, DxButtonModule, DxDropDownButtonModule, DxLoadPanelModule } from 'devextreme-angular';
import { environment } from 'src/environments/environment';
import { HorizontalMenuService } from 'src/app/services/horizontalmenu.service';
import { NotifyService } from 'src/app/services/notify.service';
import { Observable } from 'rxjs';
import { BuyingGroups } from 'src/app/models/buying-groups.model';
import { ProductPricing } from 'src/app/models/product-pricing.model';
import { ProductGroupsComponent } from '../product-groups/product-groups.component';
import { ProductCategoriesComponent } from '../product-categories/product-categories.component';
import { SuppliersComponent } from '../suppliers/suppliers.component';
import { MixMatchComponent } from '../mix-match/mix-match.component';
import { ProductsPricingComponent } from '../products-pricing/products-pricing.component';
import { PageHeaderComponent } from 'src/app/shared/page-header/page-header.component';

@Component({
    selector: 'app-products-component',
    templateUrl: './products-component.component.html',
    styleUrls: ['./products-component.component.css'],
    imports: [ DxPopupModule, DxDataGridModule, DxButtonModule, DxDropDownButtonModule, DxLoadPanelModule,
      ProductGroupsComponent, ProductCategoriesComponent, SuppliersComponent, MixMatchComponent, ProductsPricingComponent, PageHeaderComponent ],
    standalone: true
})
export class ProductsComponent {
  product_group: any;
  @ViewChild('productsGrid', { static: false }) productsGrid: DxDataGridComponent;
  product: Product[];
  dataSource: CustomStore;
  productGroupStore: CustomStore;
  count: number = 0;
  importDisabled: boolean = false;
  isStored: boolean = false;
  private apiUrl: string = environment.baseApiUrl;
  editProdGroups: boolean = false;
  editCategoryGroups: boolean = false;
  groupList: ProductGroup[];
  supplierList: Suppliers[];
  warehouseList: Warehouse[];
  product_groups: ProductGroup[] = [];
  showFilterRow: boolean | null | undefined = false;
  buyingGroups$: Observable<BuyingGroups[]>;
  productsPricing$: Observable<ProductPricing[]>;
  loading: boolean = true;
  overflowOptions = [
    { value: 1, name: 'Product Groups' },
    { value: 2, name: 'Product Categories' },
    { value: 3, name: 'Suppliers' },
    { value: 4, name: 'Mix n Match'}
  ];
  toggleStateItems = [
    { id: 'all', name: 'All' },
    { id: 'deleted', name: 'Deleted' }
  ];

  currentToggleState = this.toggleStateItems[0]; // default to 'All'
  dropdownButtonText = 'Filter By'; // Initial text for the drop-down button

  constructor(private crudService: CrudService,
              private horizontalMenuService: HorizontalMenuService,
              private notifyService: NotifyService)
  {
    this.loadData();
  }

  async loadData(filterType: 'all' | 'deleted' = 'all') {
    this.dataSource = new CustomStore<Product>({
        key: 'id',
        load: async (loadOptions) => {
            try {
                let apiUrl = `${this.apiUrl}products`;
                
                // Add 'deleted' query parameter for deleted products
                if (filterType === 'deleted') {
                    apiUrl += '?deleted=true';
                }
                
                let data = await this.crudService.getData(apiUrl).toPromise();
                
                this.loading = false;
                return data;
            } catch (error) {
                console.error('Error loading data:', error);
                this.loading = false;
                throw error;
            }
        },
      insert: async (values) => {
        if (values.product_group_name) {
           values.product_group_code = this.getProductGroupCode(values.product_group_name);
        }
        return await new Promise(async (resolve) => {
          const result: any = this.crudService.insertData(`${this.apiUrl}products`, values)
          .subscribe((result: any) => {
            this.notifyService.tellUser(result);
            resolve(result);
          });
        });
      },
      update: async (key, values) => {
        if (values.product_group_name) {
           values.product_group_code = this.getProductGroupCode(values.product_group_name);
        }
        return await new Promise(async (resolve) => {
          this.crudService.updateData(`${this.apiUrl}products`, key, values)
          .subscribe((result: any) => {
            this.notifyService.tellUser(result);
            // Refresh the grid after any update (including un-deleting)
            if (values.hasOwnProperty('deleted_at')) {
              this.refreshDataGrid();
            }
            resolve(result);
          });
        });
      },
      remove: async (key) => {
        return await new Promise(async (resolve) => {
          const result: any = this.crudService.deleteData(`${this.apiUrl}products`, key)
          .subscribe((result: any) => {
            this.notifyService.tellUser(result);
            resolve(result);
          });
        });
      }
    });
    this.crudService.getData(`${this.apiUrl}suppliers`).subscribe((result: any) => {
      this.supplierList = result;
    });
    this.crudService.getData(`${this.apiUrl}warehouses`).subscribe((result: any) => {
      this.warehouseList = result;
    });
    this.loadProductGroups();
  }
  clearFilter() {
    this.productsGrid.instance.clearFilter();
  }
onDropdownSelectionChanged(e: any) {
  console.log("Event received:", e);
  if (!e.item) {
    console.error('No item in selection changed event', e);
    return; // Prevent further execution if item is not present
  }

  this.dropdownButtonText = `${e.item.name}`;
  this.currentToggleState = e.item;
  console.log("Current toggle state set to:", this.currentToggleState);

  // Show loading panel when selecting deleted filter
  if (this.currentToggleState.id === 'deleted') {
    this.loading = true;
  }

  switch (this.currentToggleState.id) {
    case 'all':
      this.loadData('all');
      break;
    case 'deleted':
      this.loadData('deleted');
      break;
    default:
      this.loadData('all');
  }
  this.productsGrid.instance.refresh();
}

onCellPrepared(e: any) {
  // Add red background to deleted_at cells when they have a value
  if (e.rowType === 'data' && e.column.dataField === 'deleted_at' && e.data.deleted_at) {
    e.cellElement.classList.add('deleted-at-cell');
  }
}

getProductGroupCode(productGroupName: string): string{
  const matchingGroup = this.product_groups.find(
    (group) => group.product_group_name === productGroupName
  );
  if (matchingGroup) {
    return matchingGroup.product_group_code;
  }
  return '';
}

// Function to toggle the filter row visibility
toggleFilterRow(): void {
  this.showFilterRow = !this.showFilterRow;
  this.clearFilter();
}
  async loadProductGroups() {
    this.productGroupStore = new CustomStore<any>({
      key: 'id',
      load: (loadOptions) => {
        try {
          const result = this.crudService.getData(`${this.apiUrl}product-groups`, loadOptions).toPromise();
          result.then((data: any) => {
            this.product_groups = data;
          });
          return result;
        } catch (error) {
          console.error('Error loading data:', error);
          throw error;
        }
      },
      byKey: (key) => {
        const items = this.product_groups || [];
        const item = items.find((item:any) => item.id === key);
        console.log("items:",item)
        return Promise.resolve(item);
      }
    });
  }
  itemClick(e:any){
    if(e.itemData.value == 4){
      this.horizontalMenuService.seteditMixMatch(true);
    }
    if(e.itemData.value == 3){
      this.horizontalMenuService.seteditSuppliers(true);
    }
    if(e.itemData.value == 2){
      this.horizontalMenuService.seteditProductCategories(true);
    }
    if(e.itemData.value == 1){
      this.horizontalMenuService.seteditProdGroups(true);
    }
  }

  async importProductFile(): Promise<void> {
    this.importDisabled = true;
    const userDetails = localStorage.getItem('userDetails');
    const parsedDetails = JSON.parse(userDetails || '{}');
    const config = await this.crudService.getData(`${this.apiUrl}config/LatestHostFile`).subscribe((result: any[]) => {
      if (result.length > 0) {
        const config_string = result[0].config_string;
        this.crudService.getData(`${this.apiUrl}host-data?date_added=${config_string}`).subscribe(async () => {
          const response: BuyingGroups[] = await this.crudService.getData(`${this.apiUrl}buying-groups`).toPromise();
          const data = {
            main_supplier_token: parsedDetails.data.location_token || '',
            date_added: config_string
          }
          response.forEach(BuyingGroup => {
            this.crudService.updateData(`${this.apiUrl}host-data`, BuyingGroup.account_code, data).subscribe((response: any) => {
              console.log('products pricing: ', response);
            });
          });
          this.importDisabled = false;
          this.refreshDataGrid();
        });
      } else {
          this.crudService.getData(`${this.apiUrl}host-data`).subscribe(() => {
          this.importDisabled = false;
        });
      }
    });
  }

  calculateGpAmount(row: Product)
  {
    if(row.sell_price !== null && row.cost_inc_gst !== null) {
      return row.sell_price - row.cost_inc_gst;
    }
    return undefined;
  }
  getGroupList(event: ProductGroup[]) {
    this.groupList = event;
  }
  calculateGpPercent(row: Product)
  {
    if(row.sell_price !== null && row.sell_price !== 0 && row.cost_inc_gst !== null) {
      return ((row.sell_price - row.cost_inc_gst) / row.sell_price) * 100;
    }
    return undefined;
  }

  refreshDataGrid() {
    this.loadData();
    this.productsGrid.instance.refresh();
  }

  onEditorPreparing(e: any) {
    if (e.parentType === "searchPanel") {
      e.editorOptions.onValueChanged = undefined;
      e.editorOptions.onEnterKey = function(arg: any) {
      e.component.searchByText(arg.component.option("value"));
      }
    }
  }
}
